/**
 * FairwayBid – der Starttermin des Portals.
 *
 * Steht an einer Stelle, weil er an mehreren auftaucht und weil er sich
 * verschieben kann. Wer den Termin ändert, ändert ihn hier – nicht in der
 * Gestaltung.
 */

/** Wie der Termin in der Ecke steht. */
export const LAUNCH_EYEBROW = 'Start';
export const LAUNCH_DATE_LABEL = '01.01.2027';

/** Derselbe Satz für Screenreader – die Ecke ist sonst nur Grafik. */
export const LAUNCH_A11Y = 'FairwayBid startet am 1. Januar 2027.';

/**
 * Welche Abschnitte den umgeknickten Seitenrand bekommen. Bewusst eine
 * Liste von Anchor-IDs und keine Automatik: Die Ecke gehört auf das große
 * Bild der Startseite und sonst nirgendwohin.
 */
export const LAUNCH_CORNER_SECTION_IDS = ['public-start'];

export const hatStartecke = sectionId => LAUNCH_CORNER_SECTION_IDS.includes(sectionId);

/**
 * Der Starttermin als Zeitpunkt.
 *
 * Mitteleuropäische Zeit, nicht UTC: Der 1. Januar beginnt für eine
 * Golfanlage in Wölfersheim um Mitternacht in Wölfersheim, nicht eine Stunde
 * später.
 */
export const LAUNCH_AT = new Date('2027-01-01T00:00:00+01:00');

/**
 * Vorstart: Registrierung offen, Portal noch zu.
 *
 * Bis zum Start sollen sich Golfanlagen und Händler anmelden können – aber
 * noch keine Anfragen einstellen. Der Grund ist nicht Technik, sondern
 * Marktplatzlogik: Eine Anfrage, die in einem leeren Markt drei Wochen ohne
 * Angebot liegt, ist für die Anlage kein Auftakt, sondern eine Enttäuschung.
 * Und ein Händler, der nichts vorfindet, kommt nicht wieder.
 *
 * Deshalb füllt sich die Plattform erst mit Teilnehmern und geht dann auf
 * einmal auf.
 *
 * Seit dem Livegang ist das Einstellen offen: Tom fuellt den Markt selbst
 * mit den ersten Anfragen, statt auf den Starttag zu warten. Deshalb steht
 * VORSTART_STANDARD auf false - der Termin oben bleibt als Datum fuer die
 * Startecke und die Texte erhalten, sperrt aber nichts mehr.
 *
 * Zurueckdrehen ist eine Zeile: VORSTART_STANDARD auf true setzen, dann
 * entscheidet wieder der Termin. Ohne neuen Build geht es ueber die
 * Umgebungsvariable REACT_APP_FWB_VORSTART: =an sperrt das Einstellen,
 * =aus gibt es frei, ohne Angabe gilt VORSTART_STANDARD.
 */
export const VORSTART_STANDARD = false;

export const istVorStart = (now = new Date()) => {
  const schalter = process.env.REACT_APP_FWB_VORSTART;
  if (schalter === 'aus') return false;
  if (schalter === 'an') return true;
  if (!VORSTART_STANDARD) return false;
  return now.getTime() < LAUNCH_AT.getTime();
};

/** Tage bis zum Start, mindestens 0. */
export const tageBisStart = (now = new Date()) =>
  Math.max(0, Math.ceil((LAUNCH_AT.getTime() - now.getTime()) / (24 * 60 * 60 * 1000)));

/** Was im Vorstart auf dem Dashboard steht – je Zielgruppe ein Absatz. */
export const VORSTART_TEXTE = {
  customer: {
    titel: 'Ihr Konto steht. Das Portal öffnet am 1. Januar 2027.',
    text:
      'Bis dahin sammeln wir Golfanlagen und Anbieter. Anfragen lassen sich noch nicht einstellen – eine Ausschreibung, die drei Wochen ohne Angebot liegt, weil noch zu wenige Händler da sind, nützt Ihnen nichts. Am Starttag geht alles auf einmal auf, und Ihre erste Anfrage trifft auf einen gefüllten Markt.',
    hinweis:
      'Sie können jetzt schon Ihr Profil vervollständigen – Lieferland und Postleitzahl sparen Ihnen später Eingaben.',
  },
  provider: {
    titel: 'Ihr Konto steht. Das Portal öffnet am 1. Januar 2027.',
    text:
      'Bis dahin sammeln wir Golfanlagen und Anbieter. Anfragen gibt es deshalb noch keine. Am Starttag sehen Sie genau die, die zu Ihren Kategorien und Lieferländern passen – und zwar von der ersten Minute an.',
    hinweis:
      'Tragen Sie jetzt Kategorien, Lieferländer und Leistungen in Ihrem Profil ein. Danach richtet sich, welche Anfragen Sie ab dem ersten Tag erreichen – und wie Ihre Dealchance berechnet wird.',
  },
};
